<template>
  <section class="tech-panel model-architecture">
    <div class="panel-title small-title">模型架构</div>
    <img class="architecture-img" src="../../assets/img/gzc.png" alt="" />
  </section>
</template>

<style lang="less" scoped>
@import "./guidancePanelShared.less";

.model-architecture {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 22px 26px;
}

.small-title {
  width: 300px;
}

.architecture-img {
  width: 96%;
  flex: 1;
  min-height: 0;
  margin-top: 12px;
  object-fit: contain;
}
</style>
